import * as http from "./http";
import { APIUrl, AI_API_URL } from "./apiConfig";

// Export the API URLs from the centralized config
export { APIUrl, AI_API_URL };

export const innerUploadFile = (field, data) => {
    const formData = new FormData();
    formData.append(field, data.rawFile);
    return fetch(`${APIUrl}uploadFile`, {
        method: 'POST',
        body: formData
    }).then((response) => response.json())
        .then((responseJson) => { 
            return responseJson;
        })
        .catch((error) => {
            console.log(error);
        });
}

export const getBaseUrl = (url) => {
    if (url.indexOf("?") != -1) {
        url = url.substring(0, url.indexOf("?"));
    }
    return url;
}

export const UploadFile = async (field, data) => {
    if (data && data.rawFile) {
        let response = await innerUploadFile(field, data);
        if (response.files && response.files.length > 0) {
            return getBaseUrl(response.files[0].url);
        } else {
            return data;
        }
    }
    return data;
}


export const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;
    return [year, month, day].join('-');
}

export const loginUser = (user) => {
    let api = APIUrl + "user/login";
    return http.post(api, user).then(response => {
        return response;
    });
}

export const adminLogin = (credentials: { username: string; password: string }) => {
    let api = APIUrl + "login/admin_login";
    return http.post(api, credentials).then(response => {
        return response;
    });
}

// New JWT Authentication functions
export const adminJWTLogin = (credentials: { username: string; password: string; device_info?: string }) => {
    let api = APIUrl + "login/jwt_admin_login";
    return http.post(api, credentials).then(response => {
        return response;
    });
}

export const adminJWTRefresh = (data: { refresh_token: string }) => {
    let api = APIUrl + "login/jwt_refresh";
    return http.post(api, data).then(response => {
        return response;
    });
}

export const adminJWTLogout = () => {
    let api = APIUrl + "login/jwt_logout";
    return http.post(api, {}).then(response => {
        return response;
    });
}

export const adminJWTLogoutAll = () => {
    let api = APIUrl + "login/jwt_logout_all";
    return http.post(api, {}).then(response => {
        return response;
    });
}


export const deleteRecord = async (path, id) => {
    let api = APIUrl + path + "/" + id;
    return await http.del(api).then(response => {
        return response;
    });
}

export const addEntiyRecord = (resource, data) => {
    let api = APIUrl + resource;
    return http.post(api, data).then(response => {
        return response;
    });
}

export const updateEntiyRecord = (resource, data) => {
    let api = APIUrl + resource + "/" + data.id;
    return http.put(api, data).then(response => {
        return response;
    });
}

export const ChangePassword = (data) => {
    let api = APIUrl + "users/update_password";
    return http.post(api, data).then(response => {
        return response;
    });
}

export const innerUploadImportFile = (field, data) => {
    const formData = new FormData();
    formData.append(field, data.rawFile);
    return fetch(`${APIUrl}fileimport`, {
        method: 'POST',
        body: formData
    }).then((response) => response.json())
        .then((responseJson) => {
            return responseJson;
        })
        .catch((error) => {
            console.log(error);
        });
}

export const UploadImportFile = async (field, data) => {
    if (data && data.rawFile) {
        let response = await innerUploadImportFile(field, data);
        return response;
    }
    return data;
}


export const fetchSolution = (image_url, suggestion = "") => {
  let api = `${AI_API_URL}solution_from_image_by_url`;
  let data:any ={
    image_url: image_url,
    suggestion: suggestion

  }
  return http.post(api, data).then((response) => {
    return response;
  });
};

export const updateQuestionSolution = (id, solution = "") => {
  let api = `${APIUrl}question/solution/${id}`;
  let data:any ={
    solution: solution,
    id: id
  }
  return http.post(api, data).then((response) => {
    return response;
  });
};

// Dashboard APIs
export const getQuestionSummary = (questionType: string = 'regular') => {
  let api = `${APIUrl}dashboard/question_summary?question_type=${questionType}`;
  return http.get(api).then((response) => {
    return response;
  });
};

export const getQuestionsBySubject = (subjectId: string) => {
  let api = `${APIUrl}dashboard/questions_by_subject/${subjectId}`;
  return http.get(api).then((response) => {
    return response;
  });
};

export const getAllSubjects = () => {
  let api = `${APIUrl}subject`;
  return http.get(api).then((response) => {
    return response;
  });
};

// Question Analysis API
export const getQuestionsAnalysis = (params: any) => {
  let api = `${APIUrl}question/analysis`;
  const queryParams = new URLSearchParams();
  
  if (params.pagination) {
    queryParams.append('page', String(params.pagination.page));
    queryParams.append('pagesize', String(params.pagination.perPage));
  }
  
  if (params.sort) {
    queryParams.append('sortby', params.sort.field);
    queryParams.append('sortorder', params.sort.order);
  }
  
  if (params.filter && Object.keys(params.filter).length > 0) {
    queryParams.append('filter', JSON.stringify(params.filter));
  }
  
  const queryString = queryParams.toString();
  if (queryString) {
    api += `?${queryString}`;
  }
  
  return http.get(api).then((response) => {
    return {
      data: response.result || [],
      total: response.total || 0
    };
  });
};

// User Quiz Statistics API
export const getUserQuizStatistics = (params: any) => {
  let api = `${APIUrl}quiz/users_quiz_statistics`;
  const queryParams = new URLSearchParams();
  
  if (params.pagination) {
    queryParams.append('page', String(params.pagination.page));
    queryParams.append('limit', String(params.pagination.perPage));
  }
  
  if (params.sort) {
    queryParams.append('sort_by', params.sort.field);
    queryParams.append('sort_order', params.sort.order);
  }
  
  if (params.filter && Object.keys(params.filter).length > 0) {
    Object.keys(params.filter).forEach(key => {
      if (params.filter[key] !== '' && params.filter[key] !== null && params.filter[key] !== undefined) {
        queryParams.append(key, String(params.filter[key]));
      }
    });
  }
  
  const queryString = queryParams.toString();
  if (queryString) {
    api += `?${queryString}`;
  }
  
  return http.get(api).then((response) => {
    return {
      data: response.result || {},
      users: response.result?.users || [],
      pagination: response.result?.pagination || {},
      total: response.result?.pagination?.total_users || 0
    };
  });
};